/**
* @Author: zhangkaicheng
* @Date: 2025/10/15
* @LastEditors: zhangkaicheng
* @Tips: 不要用于所有 key, 只对敏感 key（如 'loginInfo'）启用
* @Description 劫持浏览器存储，实现数据加密，目前支持了PUGC通讯员投稿平台的敏感数据，后续别的项目需要使用的话，扩展 isMode 函数
**/

import SM4 from 'common-mediax/src/common/sm4';
import { SECURE_STORAGE_KEYS, SM4_KEY } from 'common-mediax/src/common/secure-storage-patch-constant';

(function patchLocalStorage() {
  // 防止重复打补丁
  if (Storage.prototype.setItem._securePatchApplied) {
    console.warn('[SecureStoragePatch] 补丁已应用，跳过重复劫持');
    return;
  }
  /**
   * 获取敏感 key 列表
   * @returns key列表
   */
  const getSecureKeys = () => {
    if (Array.isArray(SECURE_STORAGE_KEYS)) return SECURE_STORAGE_KEYS;
    if (typeof keys === 'string') return [SECURE_STORAGE_KEYS];
    return ['loginInfo'];
  };


  // M4 实例
  let sm4Instance = null;
  /**
   * 获取 SM4 实例
   * @returns SM4 实例
   */
  function getSM4() {
    if (!sm4Instance) {
      if (!SM4_KEY) {
        console.warn('[SecureStoragePatch] SM4_KEY 未设置');
        return null;
      }
      try {
        sm4Instance = new SM4(SM4_KEY);
      } catch (e) {
        console.error('[SecureStoragePatch] SM4 实例化失败', e);
      }
    }
    return sm4Instance;
  }

  // 保存原始方法
  const originalSetItem = Storage.prototype.setItem;
  const originalGetItem = Storage.prototype.getItem;

  /**
   * 重写 setItem
   * @param {*} key 键名
   * @param {*} value 值
   */
  Storage.prototype.setItem = function (key, value) {
    const secureKeys = getSecureKeys();
    if (secureKeys.includes(key)) {
      const sm4 = getSM4();
      // 单独处理PUGC的登录信息
      if (sm4) {
        try {
          // 加密
          const encrypted = sm4.encrypt(JSON.stringify(value));
          originalSetItem.call(this, key, encrypted);
          return;
        } catch (e) {
          console.error(`[SecureStoragePatch] 加密失败: ${key}`, e);
        }
      }
    }
    // 其他 key 正常处理
    originalSetItem.call(this, key, value);
  };

  /**
   * 重写 getItem
   * @param {*} key 键名
   * @returns 解密后的值
   */
  Storage.prototype.getItem = function (key) {
    const secureKeys = getSecureKeys();
    const value = originalGetItem.call(this, key);
    // 解密
    if (secureKeys.includes(key)) {
      const sm4 = getSM4();
      // 单独处理PUGC的登录信息
      if (sm4 && value) {
        try {
          const decrypted = sm4.decrypt(value);
          if (!decrypted) return null;
          // 尝试解析 JSON，失败则返回字符串
          try {
            return JSON.parse(decrypted);
          } catch {
            return decrypted;
          }
        } catch (e) {
          console.warn(`[SecureStoragePatch] 解密失败，返回原始密文: ${key}`, e);
          return value; // 返回加密串（便于调试）
        }
      }
    }
    return value;
  };

  // 标记已打补丁
  Storage.prototype.setItem._securePatchApplied = true;
})();